import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const LoginModal = ({ closeModal }) => {
  const navigate = useNavigate();
  const { login } = useAuth();
  
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  
  // Controla la pantalla de transición elegante
  const [showSuccessTransition, setShowSuccessTransition] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    const response = await login(email, password);
    
    if (!response.success) {
      setError(response.message || "La contraseña es incorrecta.");
      setIsLoading(false);
    } else {
      // 1. Activar la transición suave
      setShowSuccessTransition(true);

      // 2. Esperar a que termine la animación y navegar
      setTimeout(() => {
        closeModal();
        const user = JSON.parse(localStorage.getItem('loggedInUser'));
        // Tomamos el primer curso de su lista. Si la lista está vacía, falla seguro redirigiendo al home
        const courseId = user?.courses?.[0]; 
        if (courseId) {
            navigate(`/course-player/${courseId}`);
        } else {
            // Si no tiene cursos comprados, lo mandamos al inicio o a una página de error
            navigate("/"); 
        }
      }, 2200);
    }
  };

  return (
    <>
      {/* --- ESTILOS COMPARTIDOS (TRANSICIÓN Y MODAL) --- */}
      <style>{`
        /* Fondo difuminado general */
        .modal-backdrop-blur {
          position: fixed;
          top: 0; left: 0; width: 100%; height: 100%;
          background: rgba(0, 0, 0, 0.6);
          backdrop-filter: blur(4px);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: fadeInOverlay 0.3s forwards ease-out;
        }

        /* ----- ESTILOS DEL MODAL MINIMALISTA ----- */
        .login-card {
          background: #ffffff;
          border-radius: 12px;
          padding: 2.5rem;
          width: 100%;
          max-width: 400px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          transform: translateY(20px);
          opacity: 0;
          animation: slideUpFade 0.4s forwards ease-out 0.1s;
        }

        .btn-close-square {
          background-color: #007BFF; /* Azul vibrante */
          color: white;
          border: none;
          border-radius: 4px;
          width: 32px;
          height: 32px;
          font-weight: bold;
          font-size: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          margin-bottom: 1rem;
          transition: background-color 0.2s;
        }
        .btn-close-square:hover {
          background-color: #0056b3;
        }

        .login-title {
          font-size: 1.75rem;
          font-weight: 800;
          color: #4A4A68; /* Tono oscuro purpura/gris */
          margin-bottom: 1.5rem;
        }

        .login-form {
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .login-input {
          width: 100%;
          padding: 0.8rem 1rem;
          border: 1px solid #D1D5DB;
          border-radius: 6px;
          background-color: #F9FAFB;
          font-size: 1rem;
          color: #374151;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .login-input:focus {
          outline: none;
          border-color: #007BFF;
          box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);
          background-color: #ffffff;
        }
        .login-input::placeholder {
          color: #9CA3AF;
        }

        .login-submit-btn {
          width: 100%;
          background-color: #007BFF;
          color: white;
          font-weight: 600;
          font-size: 1.1rem;
          padding: 0.8rem;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          transition: background-color 0.2s, transform 0.1s;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 0.5rem;
        }
        .login-submit-btn:hover:not(:disabled) {
          background-color: #0069d9;
        }
        .login-submit-btn:active:not(:disabled) {
          transform: scale(0.98);
        }
        .login-submit-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .login-error-text {
          color: #6B7280; /* Gris sutil como en la imagen */
          text-align: center;
          font-size: 0.95rem;
          margin-top: 1rem;
        }

        /* ----- ESTILOS DE LA TRANSICIÓN DE ÉXITO ----- */
        .success-overlay {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: white;
        }
        
        .success-circle {
          width: 80px; height: 80px;
          border-radius: 50%;
          background: #25D366; 
          display: flex; align-items: center; justify-content: center;
          margin-bottom: 20px;
          box-shadow: 0 0 30px rgba(37, 211, 102, 0.4);
          transform: scale(0);
          animation: popIn 0.6s forwards cubic-bezier(0.175, 0.885, 0.32, 1.275) 0.1s;
        }

        .welcome-text {
          font-size: 1.5rem;
          font-weight: bold;
          opacity: 0;
          transform: translateY(20px);
          animation: slideUpFade 0.5s forwards ease-out 0.4s;
        }

        .sub-text {
          color: #E2E8F0;
          margin-top: 8px;
          opacity: 0;
          animation: slideUpFade 0.5s forwards ease-out 0.6s;
        }

        .loading-dots {
          display: flex;
          gap: 6px;
          margin-top: 15px;
        }
        .dot {
          width: 8px; height: 8px;
          background: #ffffff;
          border-radius: 50%;
          animation: bounceDot 1.4s infinite ease-in-out both;
        }
        .dot:nth-child(1) { animation-delay: -0.32s; }
        .dot:nth-child(2) { animation-delay: -0.16s; }

        /* KEYFRAMES GLOBALES */
        @keyframes fadeInOverlay { to { opacity: 1; } }
        @keyframes popIn { to { transform: scale(1); } }
        @keyframes slideUpFade { to { opacity: 1; transform: translateY(0); } }
        @keyframes bounceDot {
          0%, 80%, 100% { transform: scale(0); }
          40% { transform: scale(1); }
        }
      `}</style>

      <div className="modal-backdrop-blur">
        
        {/* --- PANTALLA DE TRANSICIÓN (Éxito) --- */}
        {showSuccessTransition && (
          <div className="success-overlay">
            <div className="success-circle">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
            <h2 className="welcome-text">¡Acceso concedido!</h2>
            <p className="sub-text">Preparando tu entorno de estudio...</p>
            <div className="loading-dots">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
        )}

        {/* --- MODAL DE LOGIN MINIMALISTA --- */}
        {!showSuccessTransition && (
          <div className="login-card">
            
            {/* Botón X de cierre superior */}
            <button onClick={closeModal} className="btn-close-square" disabled={isLoading}>
              X
            </button>

            <h2 className="login-title">Iniciar Sesión</h2>

            <form className="login-form" onSubmit={handleSubmit}>
              <input
                className="login-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Escribe tu email"
                required
                disabled={isLoading}
              />
              <input
                className="login-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••••••••"
                required
                disabled={isLoading}
              />
              
              <button 
                type="submit" 
                className="login-submit-btn"
                disabled={isLoading} 
              >
                {isLoading ? (
                  <>
                    <svg width="20" height="20" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#fff" style={{ marginRight: '8px' }}>
                        <g fill="none" fillRule="evenodd">
                            <g transform="translate(1 1)" strokeWidth="3">
                                <circle strokeOpacity=".3" cx="18" cy="18" r="18"/>
                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                    <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"/>
                                </path>
                            </g>
                        </g>
                    </svg>
                    Procesando...
                  </>
                ) : (
                  "Iniciar Sesión"
                )}
              </button>

              {/* Mensaje de error (Gris sutil debajo del botón) */}
              {error && <p className="login-error-text">{error}</p>}
            </form>
          </div>
        )}
      </div>
    </>
  );
};

export default LoginModal;